// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'General ledger'" tab="true"></sub-header>

  <div class="tab-menu no-print">
      <ul class="nav-tabs">
          <!--Commenting out this for now, screen is not yet available-->
          <!--<li class="active">-->
              <!--<a data-target="#tab_accounts_chart" data-toggle="tab" ng-click="\$ctrl.changeTitle(\$ctrl.titles.chartOfAccounts)">-->
                  <!--<span>{{\$ctrl.titles.chartOfAccounts}}</span>-->
              <!--</a>-->
          <!--</li>-->
          <li class="active">
              <a data-target="#tab_txn_categories" data-toggle="tab">
                  <span>{{\$ctrl.titles.categories}}</span>
              </a>
          </li>
          <li permissions="GL_TRANSACTIONS_WRITE">
              <a data-target="#tab_txn_mapping" data-toggle="tab">
                  <span>{{\$ctrl.titles.mapping}}</span>
              </a>
          </li>
          <li command-access="UpdateMiscTransactionUnitTemplate">
              <a data-target="#tab_misc_txn_mapping" data-toggle="tab">
                  <span>{{\$ctrl.titles.miscMapping}}</span>
              </a>
          </li>
          <li>
              <a data-target="#tab_oracle_handoff_mapping" data-toggle="tab">
                  <span>{{\$ctrl.titles.oracleHandoffMapping}}</span>
              </a>
          </li>
      </ul>
  </div>

  <div class="tab-content" style="overflow: unset">
      <div class="tab-pane active" id="tab_txn_categories">
          <transactions-category-list></transactions-category-list>
      </div>
      <div class="tab-pane" id="tab_txn_mapping">
        <div permissions="GL_TRANSACTIONS_WRITE">
          <gl-transactions-mapping></gl-transactions-mapping>
        </div>
      </div>
      <div class="tab-pane" id="tab_misc_txn_mapping">
          <div command-access="UpdateMiscTransactionUnitTemplate">
            <misc-transaction-mapping></misc-transaction-mapping>
          </div>
      </div>
      <div class="tab-pane" id="tab_oracle_handoff_mapping">
          <div>
            <oracle-handoff-mapping></oracle-handoff-mapping>
          </div>
      </div>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/general-ledger/general-ledger.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;